module.exports = "h5 {\n  padding: 4px; }\n"